const TIMEZONES = [
  "Asia/Kolkata",
  "UTC",
  "Asia/Dubai",
  "Asia/Singapore",
  "Asia/Tokyo",
  "Asia/Karachi",
  "Asia/Dhaka",
  "Australia/Sydney",
  "Europe/London",
  "Europe/Berlin",
  "Europe/Paris",
  "Europe/Moscow",
  "America/New_York",
  "America/Chicago",
  "America/Denver",
  "America/Los_Angeles",
  "America/Sao_Paulo",
  "Africa/Johannesburg"
];
function offsetMinutesAt(instant, timeZone) {
  const dtf = new Intl.DateTimeFormat("en-US", {
    timeZone,
    hourCycle: "h23",
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
    hour: "2-digit",
    minute: "2-digit",
    second: "2-digit"
  });
  const parts = dtf.formatToParts(instant);
  const get = (t) => Number(parts.find((p) => p.type === t)?.value ?? "0");
  const asUtc = Date.UTC(
    get("year"),
    get("month") - 1,
    get("day"),
    get("hour"),
    get("minute"),
    get("second")
  );
  return Math.round((asUtc - Math.floor(instant.getTime() / 1e3) * 1e3) / 6e4);
}
function isValidTimezone(timeZone) {
  try {
    new Intl.DateTimeFormat("en-US", { timeZone });
    return true;
  } catch {
    return false;
  }
}
function resolveWallClock({ year, month, day, hour = 0, minute = 0, second = 0 }, timeZone) {
  const naive = Date.UTC(year, month - 1, day, hour, minute, second);
  let guess = new Date(naive - offsetMinutesAt(new Date(naive), timeZone) * 6e4);
  const corrected = new Date(naive - offsetMinutesAt(guess, timeZone) * 6e4);
  if (corrected.getTime() !== guess.getTime()) {
    guess = corrected;
    const again = new Date(naive - offsetMinutesAt(guess, timeZone) * 6e4);
    if (again.getTime() !== guess.getTime()) guess = again;
  }
  return guess;
}
function wallClockOf(instant, timeZone) {
  const parts = new Intl.DateTimeFormat("en-US", {
    timeZone,
    hourCycle: "h23",
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
    hour: "2-digit",
    minute: "2-digit",
    second: "2-digit"
  }).formatToParts(instant);
  const get = (t) => Number(parts.find((p) => p.type === t)?.value ?? "0");
  return {
    year: get("year"),
    month: get("month"),
    day: get("day"),
    hour: get("hour"),
    minute: get("minute"),
    second: get("second")
  };
}
function formatInZone(instant, timeZone) {
  return new Intl.DateTimeFormat("en-GB", {
    timeZone,
    day: "numeric",
    month: "short",
    year: "numeric",
    hour: "2-digit",
    minute: "2-digit",
    hour12: true
  }).format(instant);
}
function zoneLabel(instant, timeZone) {
  try {
    const parts = new Intl.DateTimeFormat("en-US", {
      timeZone,
      timeZoneName: "short"
    }).formatToParts(instant);
    return parts.find((p) => p.type === "timeZoneName")?.value ?? timeZone;
  } catch {
    return timeZone;
  }
}
function splitDuration(nowMs, targetMs) {
  const totalMs = targetMs - nowMs;
  if (totalMs <= 0) {
    return { days: 0, hours: 0, minutes: 0, seconds: 0, totalMs, elapsed: true };
  }
  const sec = Math.floor(totalMs / 1e3);
  return {
    days: Math.floor(sec / 86400),
    hours: Math.floor(sec % 86400 / 3600),
    minutes: Math.floor(sec % 3600 / 60),
    seconds: sec % 60,
    totalMs,
    elapsed: false
  };
}
const DEFAULT_BIRTHDAY = { year: 2026, month: 12, day: 12 };
const DEFAULT_TIMEZONE = "Asia/Kolkata";
const DEFAULT_LETTER = `Happy Birthday, Baby. \u2764\uFE0F

If I could be beside you at this very moment, I would hold you close and remind you how much you mean to me. Even though we're far apart, you always have a special place in my heart.

I made this little world just for you, with every detail chosen to make you smile. You deserve happiness, beautiful memories, and all the love this world can give.

Happy Birthday, my Baby. Today, tomorrow, and in every beautiful chapter ahead. \u2764\uFE0F\u267E\uFE0F`;
const DEFAULT_TEASER = "Something special is waiting for you, Baby. \u2764\uFE0F";
const DEFAULT_HEADING = "HAPPY BIRTHDAY, BABY \u2764\uFE0F";
const DEFAULT_FINAL_MESSAGE = "Whatever the year brings, you will always be my favourite part of it. Happy birthday, my love. \u2764\uFE0F\u267E\uFE0F";
export {
  DEFAULT_BIRTHDAY,
  DEFAULT_FINAL_MESSAGE,
  DEFAULT_HEADING,
  DEFAULT_LETTER,
  DEFAULT_TEASER,
  DEFAULT_TIMEZONE,
  TIMEZONES,
  formatInZone,
  isValidTimezone,
  resolveWallClock,
  splitDuration,
  wallClockOf,
  zoneLabel
};
